import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tokens: {},
  userData: {},
  EmployeeId: '',
  CompanyId: '',
  FirstName: '',
  LastName: '',
  Image: '',
  EmployeeCode: '',
  RefreshToken: '',
  BearerToken: '',
  RefreshTimestamp: '',
  WriteServicesList: [],
};

const AuthSlice = createSlice({
  name: "AuthSlice",
  initialState,
  reducers: {
    setAuthTokens: (state, action) => {
      return { ...state, tokens: action.payload.token };
    },
    saveLoggedUserData: (state, action) => {
      return { ...state, userData: action.payload, }
    },
    saveEmployeeId: (state, action) => {
      return { ...state, EmployeeId: action.payload }
    },
    saveUserDetails: (state, action) => {
      return { ...state, CompanyId: action.payload.CompanyId, FirstName: action.payload.FirstName, LastName: action.payload.LastName, Image: action.payload.Image, EmployeeCode: action.payload.EmployeeCode }
    },
    saveTokens: (state, action) => {
      return { ...state, RefreshToken: action.payload.refreshToken.toString(), BearerToken: action.payload.accessToken.toString() }
    },
    saveRefreshTimestamp: (state, action) => {
      return { ...state, RefreshTimestamp: action.payload }
    },
    saveWriteServicesList: (state, action) => {
      return { ...state, WriteServicesList: action.payload }
    }
  },
});

export const { setAuthTokens, saveRefreshTimestamp, saveLoggedUserData, saveEmployeeId, saveUserDetails, saveTokens, saveWriteServicesList } = AuthSlice.actions;
export default AuthSlice.reducer;
